<template>
  <b-nav-item
    v-if="isPermitted('request')"
    right
    :title="count"
    @click="navToRequest"
  >
    <feather-icon
      class="text-body"
      icon="MessageSquareIcon"
      size="21"
    />
  </b-nav-item>
</template>

<script>
import {
  BNavItem,
} from 'bootstrap-vue'
import { getUserData, isPermitted } from '@/auth/utils'

export default {
  components: {
    BNavItem,
  },
  data() {
    return {
      badge: null,
      count: null,
    }
  },
  created() {
    this.userData = getUserData()
  },
  methods: {
    isPermitted(code) {
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    navToRequest() {
      if (this.$route.path !== '/request') this.$router.push({ name: 'request' })
    },
  },
}
</script>
